import opDevCall from '@/mixins/global-storage.js';


const CACHE_TTL_MS = 3600000;

const TEMPLATE_CACHE = {};

const publicGroupVideoTemplate = {
  mixins: [ opDevCall ],

  methods: {
    cachePublicGroupVideoTemplate(templateId, template) {
      TEMPLATE_CACHE[templateId] = { t: new Date(), template };
    },

    async getPublicGroupVideoTemplate(template_id) {
      if (!TEMPLATE_CACHE[template_id] || ((new Date()) - TEMPLATE_CACHE[template_id].t > CACHE_TTL_MS)) {
        const template = await this.$call('get-group-video-template', { template_id });
        this.cachePublicGroupVideoTemplate(template_id, template);
      }
      return TEMPLATE_CACHE[template_id].template;
    }
  }
};

export { publicGroupVideoTemplate };
